import { useState } from 'react'
import { Badge } from 'react-bootstrap'
import * as IconsBi from "react-icons/bi";
import { toast } from 'react-toastify';


export const dictionary = {
    // 'app': 'fjr',
    'app': 'rating',
    'base-fjr': {
        'basename': 'admin',
        'title': 'IRIB - Bazargani',
        'title_fa': 'سامانه',
        'sidebarName': 'سامانه',
    },
    'base-rating': {
        'basename': '',
        'title': 'IRIB - Bazargani - Rating',
        'title_fa': 'سامانه ارزیابی و رتبه بندی بازرگانی',
        'sidebarName': 'ارزیابی و رتبه بندی بازرگانی',
    },
    'backend': {
        'sections': {
            'admin': 'پنل مدیریت',
            'user': 'پنل کاربری',
        },
        'models': {
            'App\\Models\\User': 'کاربر',
            'App\\Models\\Category': 'دسته بندی',
            'App\\Models\\Property': 'ویژگی',
            'App\\Models\\Comment': 'نظر کاربر',
        },
        'functions': {
            'store': 'ایجاد',
            'update': 'بروزرسانی',
            'reset_password': 'بازنشانی رمز ورود',
            'inventory_update': 'بروزرسانی موجودی',
            'update_status': 'بروزرسانی وضعیت',
            'accept': 'تائيد نظر',
            'reject': 'رد نظر',
            'toggle': 'تغییر وضعیت',
            'favorite_add': 'افزودن به علاقمندیها',
            'favorite_delete': 'حذف از علاقمندیها',
            'like_add': 'ثبت پسندیدم',
            'like_delete': 'حذف پسندیدم',
            'add_comment': 'ثبت نظر',
            // 'store': '',
        },
        'primaryFields': {
            'App\\Models\\User': ['name', 'last_name'],
            'App\\Models\\Category': ['title'],
            'App\\Models\\Product': ['title'],
            'App\\Models\\Comment': ['comment'],
        }
    },
    'fields': {
        'category': {
            'department': 'متولی',
            'parent': 'والد',
            'title': 'عنوان',
            'summary': 'خلاصه توضیحات',
            'content': 'توضیحات',
            'category': 'دسته (های) محتوا',
            'slug': 'آدرس یکتا (Slug)',
            'tag': 'کلیدواژه',
            'picture': 'تصاویر',
            'current_picture': 'تصاویر فعلی',

            'upload_picture': 'آپلود تصویر جدید',
            'status': 'وضعیت',
            'production_date': 'تاریخ تولید',
            'expire_date': 'تاریخ انقضاء',
            
            'production_start_at': 'زمان شروع تولید',
            'production_end_at': 'زمان پایان تولید',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
        },

        'question': {
            'department': 'متولی',
            'category': 'دسته',
            'title': 'عنوان',
            'description': 'توضیحات',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
            'answer': 'پاسخ',
            'answers': 'پاسخها',
            'answer_category': 'دسته پاسخ',
            'repetition_interval': 'دوره تکرار (روز)',
            'answer_type': 'نوع پاسخ',
            'answer_properties': 'ویژگیهای پاسخ',

            'media': 'شرکت',
            'question': 'سنجه',
            'start': 'تاریخ ثبت - از',
            'end': 'تاریخ ثبت - تا',
        },

        'answer': {
            'title': 'عنوان دسته',
            'description': 'توضیحات',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
            'answer': 'پاسخ',
            'answers': 'پاسخها',
        },

        'user': {
            'type': 'نوع کاربری',
            'department': 'واحد سازمانی',
            'gender': 'جنسیت',
            'is_admin': 'دسترسی به پنل مدیریت',
            'name': 'نام ',
            'last_name': 'نام خانوادگی',
            'code': 'کد پرسنلی',
            'national_id': 'کد ملی',
            'email': 'ایمیل',
            'mobile': 'موبایل',
            'password': 'رمز ورود',
            'password_confirmation': 'تکرار رمز ورود',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
        },

        'customer': {
            'gender': 'جنسیت',
            'name': 'نام ',
            'last_name': 'نام خانوادگی',
            'national_id': 'کد ملی',
            'email': 'ایمیل',
            'mobile': 'موبایل',
            'password': 'رمز ورود',
            'password_confirmation': 'تکرار رمز ورود',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
        },

        'department': {
            'parent': 'سلسله مراتب',
            'name': 'عنوان ',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
        },

        'group': {
            'code': 'کد گروه',
            'name': 'عنوان',
            'department': 'واحد سازمانی',
            'members': 'اعضاء',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
        },

        'media-group': {
            'name': 'عنوان',
            'media': 'شرکت (ها)',
            'tag': 'تگ (ها)',
            'updatable': 'بروزرسانی خودکار',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
        },

        'media-tag': {
            'name': 'عنوان',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
        },

        'options': {
            'title': 'عنوان',
        },

        'assessments': {
            'title': 'عنوان',
            'group': 'گروه کاری',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',

            'import_file': 'فایل اکسل نتایج',
            'import_sample_file': 'الگوی فایل نتایج',
            'import_sample_file_with_media_and_question': 'فایل نتایج با سنجه‌ها و شرکت‌ها',
            'import_media_list': 'فهرست شرکتهای ارزیابی',
        },

        'scoring-pattern': {
            'title': 'عنوان',
            // 'group': 'گروه کاری',
            // 'repetition_interval': 'دوره تکرار (روز)',
            'start': 'بازه زمانی نتایج - شروع',
            'end': 'بازه زمانی نتایج - پایان',
            'department': 'واحد سازمانی',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
            'description': 'توضیحات',
        },

        'dashboard-scoring-pattern': {
            'title': 'عنوان الگوی رتبه‌بندی',
        },

        'media': {
            'name_fa': 'نام فارسی',
            'name_en': 'نام انگلیسی',
            'domain': 'دامنه',
            'economic_code': 'کد اقتصادی',
            'accounting_code': 'سرفصل مالی',
            'national_id': 'شناسه ملی / کد ملی',
            'license_code': 'شماره مجوز',
            'validity': 'وضعیت مجوز',
            'tag': 'تگ (ها)',
            'status': 'وضعیت',
            'registrant': 'ثبت کننده',
            'created_at': 'زمان ثبت',
            'last_update': 'زمان آخرین تغییرات',
        },

    
    }
}

export const options = {
    'posts': {
        'single':'سمت',
        'plural':'سمتهای عوامل',
    },
    'age-ratings': {
        'single':'رده سنی',
        'plural':'رده های سنی',
    },
    'genres': {
        'single':'ژانر',
        'plural':'ژانرها',
    },
    'video-formats': {
        'single':'کیفیت ویدئو',
        'plural':'کیفیتهای ویدئو',
    },
    'audio-formats': {
        'single':'کیفیت صدا',
        'plural':'کیفیتهای صدا',
    },
}

export const fields_array_normalize = (arr) => {
    let start = Math.floor(Math.random() * 1000000) + 100000;
    arr.map((item,index) => {
        item.id = start + index
    })
}

export let serverErrors = null;
export const emptyServerError = () => {
    serverErrors = null
}
// export const [serverErrors, setServerErrors] = useState(null);
export const handleServerError = (data,schema,setError) => {
    // console.log('Run handleServerError:',data,data?.data,schema,setError)
    let message = 'خطا!'
    if(data?.message !== "true" && data?.message !== "false")
        message = data?.message
    toast.error(message)
    serverErrors = data?.data
    serverErrors = {
        message: [data?.message],
        ...serverErrors,
    }
    if(data?.data !== undefined && data?.data !== null)
        schema?._nodes?.map(item => {
            setError(item, { type: 'custom', message: data?.data[item]?.map((item2,index2) => { 
                return (
                    <p key={index2}>{item2}</p>
                )
            }) });
        })
}


export const handleSelectFile = (e,getValues,reset,field_name) => {
    let values = eval(getValues)()
    reset({
        ...values,
        [field_name]: e.target.files[0]
    })
}

export const handleSelectMultipleFiles = (e,getValues,reset,field_name) => {
    console.log('Run handleSelectMultipleFiles:',e,field_name)
    let h1 = []
    Array.from(e.target.files).forEach(file => { 
        h1.push(file)
    });

    let values = eval(getValues)()
    reset({
        ...values,
        [field_name]: h1
    })
}

export const threePoint = <span className="px-3">...</span>

export const requiredIndicator = <span className="text-danger"> *</span>

export const fieldTypes = [
    { value: 'input', label: 'متنی'},
    { value: 'select', label: 'انتخابی'},
    { value: 'date', label: 'تاریخ'},
]

export const selectTypes = [
    { value: 0, label: 'تک گزینه'},
    { value: 1, label: 'چند گزینه'},
]

export const answerTypes = [
    { value: 'write_in', label: 'ورود داده'},
    { value: 'options', label: 'انتخابی'},
]

// export const selectBaseStyles = {
//     control: base => ({
//         ...base,
//         fontSize: "14px",
//         borderRadius: ".375rem",
//         minHeight: 37,
//         boxShadow: 'none',
//         color:'green',
//     }),
//     option: base => ({
//         ...base,
//         fontSize: '14px'
//     })
// };

// export const selectInvalidStyles = {
//     control: base => ({
//         ...base,
//         // fontSize: "14px",
//         borderRadius: ".375rem",
//         // // height: 38,
//         minHeight: 37,
//         // boxShadow: 'none',
//         borderColor: 'red',
//         zIndex: '9999',
//     }),
//     // option: base => ({
//     //     ...base,
//     //     // fontSize: '14px'
//     // })
// };


export const selectBaseStyles = {
    control: base => ({
        ...base,
        fontSize: "14px",
        borderRadius: ".375rem",
        minHeight: 37,
        boxShadow: 'none',
        color:'green',
    }),
    option: base => ({
        ...base,
        fontSize: '14px'
    })
};

export const selectInvalidStyles = {
    control: base => ({
        ...base,
        // fontSize: "14px",
        borderRadius: ".375rem",
        // // height: 38,
        minHeight: 37,
        // boxShadow: 'none',
        borderColor: 'red',
        zIndex: '9999',
    }),
    // option: base => ({
    //     ...base,
    //     // fontSize: '14px'
    // })
};


export const Status = []
Status['waiting'] = <Badge bg="info" className="badge p-2 rounded-1" >در انتظار</Badge>
Status['accept'] = <Badge bg="success" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >تائيد شده</Badge>
Status['reject'] = <Badge bg="danger" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >عدم تائيد</Badge>
Status[-1] = <Badge bg="secondary" className="badge bg-secondary p-2 rounded-1" >حذف شده</Badge>
Status[0] = <Badge bg="secondary" className="badge bg-warning p-2 rounded-1" >غیر فعال</Badge>
Status[1] = <Badge bg="secondary" className="badge bg-success p-2 rounded-1" >فعال</Badge>

export const ValidityStatus = []
ValidityStatus['true'] = <Badge bg="success" className="badge p-2 rounded-1 w-100" >معتبر</Badge>
ValidityStatus['false'] = <Badge bg="danger" className="p-2 rounded-1 w-100" >نامعتبر</Badge>

export const MdiaTagType = []
MdiaTagType['static'] = <Badge bg="primary" className="badge p-2 rounded-1 w-100" >ثابت</Badge>
MdiaTagType['dynamic'] = <Badge bg="info" className="p-2 rounded-1 w-100" >متغیر</Badge>

export const AnswerType = []
AnswerType['options'] = <Badge bg="info" className="badge p-2 rounded-1 w-100" >انتخابی</Badge>
AnswerType['write_in'] = <Badge bg="primary" className="p-2 rounded-1 w-100" >ورود داده</Badge>

export const AnswerProperty = []
AnswerProperty['positive'] = <Badge bg="info" className="badge p-2 rounded-1 mb-1" >اعداد مثبت و صفر</Badge>
AnswerProperty['negative'] = <Badge bg="info" className="p-2 rounded-1 mb-1" >اعداد منفی</Badge>
AnswerProperty['decimal'] = <Badge bg="info" className="p-2 rounded-1 mb-1" >اعداد اعشاری</Badge>


export const OrderStatus = {
    waiting: <Badge bg="info" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >در انتظار</Badge>,
    in_progress: <Badge bg="warning" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >در دست بررسی</Badge>,
    accepted: <Badge bg="purple" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >تائيد شده</Badge>,
    collecting: <Badge bg="primary" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >در حال جمع آوری</Badge>,
    delivery: <Badge bg="green" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >تحویل دهی</Badge>,
    delivered: <Badge bg="success" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >تحویل داده شده</Badge>,
    canceled: <Badge bg="dark" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >لغو</Badge>,
    declined: <Badge bg="danger" className="p-2 rounded-1 w-100" style={{maxWidth:'110px'}} >عدم تائيد</Badge>,
    //orange
}

export const OrderStatusIcons = {
    waiting: <IconsBi.BiCheckCircle style={{color:'red',fontSize:'40px'}} />,
    in_progress: <IconsBi.BiCheckCircle style={{color:'red',fontSize:'40px'}} />,
    accepted: <IconsBi.BiCheckCircle style={{color:'red',fontSize:'40px'}} />,
    collecting: <IconsBi.BiCheckCircle style={{color:'red',fontSize:'40px'}} />,
    delivery: <IconsBi.BiCheckCircle style={{color:'red',fontSize:'40px'}} />,
    delivered: <IconsBi.BiCheckCircle style={{color:'red',fontSize:'40px'}} />,
    canceled: <IconsBi.BiCheckCircle style={{color:'red',fontSize:'40px'}} />,
    declined: <IconsBi.BiCheckCircle style={{color:'red',fontSize:'40px'}} />,
}


export const CategoryTypes = []
CategoryTypes['single'] = <IconsBi.BiFile className="text-info" style={{fontSize:'22px'}} />
CategoryTypes['multiple'] = <IconsBi.BiCollection className="text-info" style={{fontSize:'22px'}} />
CategoryTypes['link'] = <IconsBi.BiLink className="text-info" style={{fontSize:'22px'}} />

export const TagTypes = []
TagTypes['file'] = <Badge bg="primary" className="badge bg-primary p-2 rounded-1" >فایل</Badge>
TagTypes['article'] = <Badge bg="info" className="badge bg-info p-2 rounded-1" >مطلب</Badge>

export const statusTypes = [
    { value: 1, label: 'فعال/قابل مشاهده' },
    { value: 0, label: 'غیر فعال/غیر قابل مشاهده' },
    { value: -1, label: 'حذف' },
]

export const publishStatusTypes = [
    { value: 'playing', label: 'در حال پخش' },
    { value: 'finish', label: 'اتمام پخش' },
]

export const yesNoOptions = [
    { value: 'yes', label: 'بله' },
    { value: 'no', label: 'خیر' },
]

export const userTypeOptions = [
    { value: 'admin', label: 'مدیر سیستم' },
    { value: 'operator', label: 'بهره بردار' },
    { value: 'user', label: 'کاربر' },
]


export const hasOptions = [
    { value: 'yes', label: 'دارد' },
    { value: 'no', label: 'ندارد' },
]

export const genders = [
    { value: 'female', label: 'خانم' },
    { value: 'male', label: 'آقا' },
]

export const discountTypes = [
    { value: 'percent', label: 'درصد'},
    { value: 'fix_amount', label: 'مبلغ ثابت'},
]

export const TinyAPIKey = '12yuxmbympwpaejmxti8igq7lu4bw6pqkomp1mxhy61onlio'

export const Tiny_plugins = [
    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
]

export const Tiny_toolbar = 'code | undo redo | blocks | ' +
'bold italic forecolor | alignleft aligncenter ' +
'alignright alignjustify | bullist numlist outdent indent | ' +
'removeformat | help'


export const numberWithCommas = (x) => {
    if(parseFloat(x) > 0)
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    else 
        return x;
}

export const toPersianNumber = (number) => {
  if (number === null || number === undefined) return '';
  
  const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
  const englishDigits = '0123456789';
  
  return String(number)
    .replace(/[0-9]/g, (digit) => persianDigits[englishDigits.indexOf(digit)]);
};